import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TagModule } from 'primeng/tag';
import { CardRowComponent } from './components/card-row/card-row.component';
import { PasswordRequirementsComponent } from './components/password-requirements/password-requirements.component';
import { AutocompleteDirective } from './directives/autocomplete.directive';
import { FixRecaptchaWidgetDirective } from './directives/fix-recaptcha-widget.directive';
import { FixToggleMaskDirective } from './directives/fix-toggle-mask.directive';

@NgModule({
  declarations: [
    CardRowComponent,
    PasswordRequirementsComponent,
    FixRecaptchaWidgetDirective,
    FixToggleMaskDirective,
    AutocompleteDirective,
  ],
  imports: [CommonModule, TranslateModule, TagModule],
  exports: [
    CardRowComponent,
    PasswordRequirementsComponent,
    FixRecaptchaWidgetDirective,
    FixToggleMaskDirective,
    AutocompleteDirective,
  ],
})
export class SharedModule {}
